// Shared constants/helpers for the plain-OAuth-redirect fallback path used
// by GoogleSignInButton when the browser has no native FedCM support (see
// that file for why). GoogleAuthCallbackPage is the return leg.

export const GOOGLE_AUTH_CALLBACK_PATH = "/auth/google/callback";
export const GOOGLE_OAUTH_STATE_KEY = "google_oauth_state";
export const GOOGLE_OAUTH_RETURN_KEY = "google_oauth_return";

export function buildGoogleAuthUrl({ clientId, state, locale }) {
  const url = new URL("https://accounts.google.com/o/oauth2/v2/auth");
  url.searchParams.set("client_id", clientId);
  url.searchParams.set("redirect_uri", `${window.location.origin}${GOOGLE_AUTH_CALLBACK_PATH}`);
  // Also requesting "token" (not just "id_token") gets us an access token
  // alongside it — the id_token Google returns for this generic OAuth
  // endpoint doesn't reliably carry profile claims the way GIS's own
  // Sign-In-With-Google credential does, even with scope=profile, so
  // GoogleAuthCallbackPage falls back to the access token + userinfo
  // endpoint to get the name for prefilling onboarding.
  url.searchParams.set("response_type", "id_token token");
  url.searchParams.set("scope", "openid email profile");
  url.searchParams.set("nonce", state);
  url.searchParams.set("state", state);
  url.searchParams.set("prompt", "select_account");
  url.searchParams.set("hl", locale === "ar" ? "ar" : "en");
  return url.toString();
}

// Best-effort: only used to prefill the onboarding name field, never
// required for sign-in itself, so callers should swallow failures here.
export async function fetchGoogleProfileName(accessToken) {
  const res = await fetch("https://openidconnect.googleapis.com/v1/userinfo", {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!res.ok) return null;
  const data = await res.json();
  return data.name || null;
}
